// removed by extract-text-webpack-plugin
module.exports = {"sec":"CountDown__sec__afgUg29H","label":"CountDown__label__1JBJj3J3","time":"CountDown__time__6yG3-m3c"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CountDown/CountDown.scss
// module id = /0D4
// module chunks = 0